export const SET_LOADING = 'rewards/orders/set_loading';
export const SET_ORDERS = 'rewards/orders/set_orders';
export const SET_STORE = 'rewards/orders/set_store';
export const ADD_ORDER = 'rewards/orders/add_order';



// WEBPACK FOOTER //
// ./src/store/rewards/orders/types.js